"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserGroupStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useUserGroupStore = (0, pinia_1.defineStore)('userGroupStore', {
    state: () => ({
        loading: false,
        userGroups: []
    }),
    getters: {},
    actions: {
        getUserGroups(router, query = {}) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_user_groups_api', query: query }).href)
                    .then((response) => {
                    let userGroups = [];
                    if (Array.isArray(response['hydra:member'])) {
                        response['hydra:member'].forEach(element => {
                            if (element['@type'] !== 'UserGroup') {
                                return;
                            }
                            userGroups.push(element);
                        });
                    }
                    this.userGroups = userGroups;
                    this.loading = false;
                    resolve(response);
                })
                    .catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        createUserGroup(router, userRequest) {
            this.loading = true;
            let options = { body: JSON.stringify(userRequest), method: 'POST' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_user_groups_api' }).href, options).then(response => {
                    this.loading = false;
                    resolve(response);
                }).catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        updateUserGroup(router, userRequest, id) {
            this.loading = true;
            let options = { body: JSON.stringify(userRequest), method: 'PATCH' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_user_groups_api', params: { id: id } }).href, options).then(response => {
                    this.loading = false;
                    resolve(response);
                }).catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        deleteUserGroup(router, id) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_user_groups_api', params: { id: id } }).href, { method: 'DELETE' })
                    .then(response => {
                    this.loading = false;
                    resolve();
                }).catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
    },
});
